import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button } from '@shared/widgets';
import CheckmarkIcon from '@assets/icons/messages/checkmark.svg';

interface SentProps {
  onClose: (value: boolean) => void;
}

export const Sent = (props: SentProps) => {
  const { t } = useTranslation('messages');

  return (
    <div className='flex items-center justify-center w-full h-full'>
      <div className='bg-white text-[#27272b] text-[16px] max-w-[400px] p-[30px] w-[calc(100%-32px)]'>
        <div className='flex justify-center mb-[20px]'>
          <CheckmarkIcon />
        </div>
        <div className='mb-[20px] text-center'>{t('modals.sent.title')}</div>
        <div className='flex justify-center'>
          <Button
            className={clsx('max-w-[120px] bg-[#dc291c] border-[#dc291c]')}
            fullWidth
            caption={t('buttons.ok', { ns: 'common' })}
            active
            onClick={() => props.onClose(false)}
          />
        </div>
      </div>
    </div>
  );
};
